// extracted by mini-css-extract-plugin
export default {"button":"TnSidebarLanguages_button__aqt62","item":"TnSidebarLanguages_item__Yv3oD"};